const outOfRange = <T>(i: number, j: number, arr: T[]) =>
  Math.max(i, j) >= arr.length || Math.min(i, j) < 0

export const swapItems = <T>(arr: T[], i: number, j: number): T[] => {
  if (outOfRange(i, j, arr)) {
    return arr
  }

  const newArr = [...arr]
  const value1 = newArr[i]
  const value2 = newArr[j]
  newArr[j] = value1
  newArr[i] = value2
  return newArr
}
